import type * as React from "react";
import { redirect } from "next/navigation";

type BookingStepThreeRedirectPageProps = {
  searchParams: Promise<Record<string, string | string[] | undefined>>;
};

const BookingStepThreeRedirectPage: React.FC<
  BookingStepThreeRedirectPageProps
> = async ({ searchParams }) => {
  const params = await searchParams;
  const query = new URLSearchParams();

  for (const [key, value] of Object.entries(params)) {
    if (typeof value === "string") {
      query.set(key, value);
    } else if (Array.isArray(value)) {
      value.forEach((entry) => query.append(key, entry));
    }
  }

  const destination =
    query.size > 0
      ? `/booking/offercheckout?${query}`
      : "/booking/offercheckout";
  redirect(destination);
};

export default BookingStepThreeRedirectPage;
